export const initialInAppPurchases = {
	isModalOpen: false,
	productId: 'test-non-consumable',
	isPro: false,
}
